import { FaStar } from "react-icons/fa6";
export default function TopManufactorerBadge() {
    return (
        <div className={`
            relative px-2 py-0.5 text-12 font-text rounded-full transition-all font-medium
            bg-purple-600/10 text-purple-700/90
            w-fit flex items-center justify-center overflow-hidden
          `}>
            <FaStar className="size-3 mr-1 text-purple-600/70" />
            TOP PHARMACY
        </div>
    );
}